import type { LocaleOfStoreType } from "@beautypie/core";

export const getCancellationLink = (locale: LocaleOfStoreType): string => {
  return locale === "en-GB"
    ? "https://beautypiehelp.zendesk.com/hc/en-gb/articles/360021483459-HOW-DO-I-CANCEL-MY-MEMBERSHIP-"
    : "https://beautypiehelp-us.zendesk.com/hc/en-us/articles/360021483479-HOW-DO-I-CANCEL-MY-MEMBERSHIP-";
};

export const contactMemberHappinessLink = (
  locale: LocaleOfStoreType
): string => {
  return locale === "en-GB"
    ? "https://beautypiehelp.zendesk.com/hc/en-gb/requests/new"
    : "https://beautypiehelp-us.zendesk.com/hc/en-us/articles/360021400380-CONTACT-US";
};

export const getReturnsPolicyLink = (locale: LocaleOfStoreType): string => {
  return locale === "en-GB"
    ? "https://beautypiehelp.zendesk.com/hc/en-gb/articles/360014621880-CAN-I-RETURN-A-BEAUTY-PIE-ITEM-IF-I-DON-T-LIKE-IT-"
    : "https://beautypiehelp.zendesk.com/hc/en-us/articles/360014621880-CAN-I-RETURN-A-BEAUTY-PIE-ITEM-IF-I-DON-T-LIKE-IT-";
};
